import * as React from 'react';
import {Switch, Route} from 'react-router-dom';
import NotFound from '../pages/NotFound/NotFound';
import PolicySearchPage from '../pages/PolicySearchPage/PolicySearchPage';
import PaymentPage from '../pages/PaymentPage';
import PaymentReceived from '../pages/PaymentReceived';

const Routes = () => {
  const SwitchComponent = Switch as any;
  const RouteComponent = Route as any;
  return (
    <SwitchComponent>
      <RouteComponent exact path='/' component={PolicySearchPage} />
      <RouteComponent exact path='/pay-now' component={PaymentPage} />
      <RouteComponent exact path='/payment-received' component={PaymentReceived} />
      <RouteComponent component={NotFound} />
    </SwitchComponent>
  );
};

export default Routes;
